import rest from '../../rest/config'

const state = {
  totalRankList: {},
  personalRankList: {},
  storeRankList: {},
  totalNumber: 0
}

const actions = {
  async getTotalRankList({ commit }) {
    const result = await rest.rank.getTotalRankList()
    if (result.code !== 0) {
      return
    }
    commit('UPDATE_TOTAL_RANK_LIST', result.data)
    return result.data
  },
  async getPersonalRankList({ commit }, { type, page, count }) {
    const result = await rest.rank.getPersonalRankList(type)({ page, count })
    if (result.code !== 0) {
      return
    }
    commit('UPDATE_PERSONAL_RANK_LIST', result.data)
    commit('UPDATE_TOTAL_NUMBER', result.total_evaluators)
    return result.data
  },
  async getStoreRankList({ commit }, { type, page, count }) {
    const result = await rest.rank.getStoreRankList(type)({ page, count })
    if (result.code !== 0) {
      return
    }
    commit('UPDATE_STORE_RANK_LIST', result.data)
    commit('UPDATE_TOTAL_NUMBER', result.total_stores)
    return result.data
  }
}

const mutations = {
  'UPDATE_TOTAL_RANK_LIST'(state, totalRankList) {
    state.totalRankList = totalRankList
  },
  'UPDATE_PERSONAL_RANK_LIST'(state, personalRankList) {
    state.personalRankList = personalRankList
  },
  'UPDATE_STORE_RANK_LIST'(state, storeRankList) {
    state.storeRankList = storeRankList
  },
  'UPDATE_TOTAL_NUMBER'(state, totalNumber) {
    state.totalNumber = totalNumber
  }
}

export default {
  state,
  actions,
  mutations,
  namespaced: true
}
